<template>
  <div id="chart-line" v-loading="chartLoading">

      <div id="plotly" ref="plotly" style="min-height:260px;max-height:260px"/>
      <ChartTimeMini
  :rawData="rawData"
  :samplingRate="samplingRate"
  v-model="visibleRange"
  ></ChartTimeMini>
    <el-row class="toolbox">
      <el-col>
        <el-form
          ref="form"
          inline
          label-position="top"
          label-width="100px"
          size="small"
        >
          <el-form-item :label="$t('measurement.window')">
            <el-select v-model="window">
              <el-option
                v-for="window in windows"
                :key="window"
                :label="window"
                :value="window"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('measurement.lagSize')">
            <el-select v-model="lagSize">
              <el-option
                v-for="n in [256,512,1024,2048,4096,9192]"
                :key="n"
                :label="n"
                :value="n"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Plotly from "./Plotly"

import cachios from "cachios";
import ChartTimeMini from "./Chart_TimeMini"
export default {
  name: "autocorellation-chart",
  events: [],
  props: {
    rawData: {
      type: Array,
    },
    samplingRate: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ChartTimeMini
  },
  data() {
    return {
      chartLoading:true,
     series: [
        {
          x: [],
          y: [],
          z: [],
        },
      ],
      lagSize:1024,
      visibleRange:[],
      window:"rectangular",
      windows: ["rectangular", "hanning", "flattop", "hamming", "blackman"],
       layout: {
        xaxis: {
          title: {
            text: `${this.$t('measurement.lag')}`,
          },
        },
        yaxis: {
          title: {
            text: `${this.$t('chart.autoCorrelation')}`,
           range: [-1, 1]
          },
        },
        zaxis: {
    type: 'log',
    autorange: true
  },
        height: 260,
        margin: {
          l: 50,
          r: 50,
          b: 50,
          t: 30,
          pad: 0,
        },
        displaylogo: false,
      },
       modebar: {
          orientation: "v",
        },
    };
  },
  mounted(){
    this.init()
  },
  methods: {
  
    init() {
       this.chartLoading = true;
      cachios
        .post(`${process.env.VUE_APP_VIBRATION_APIURL}/signal/auto-correlation`, {
          window:this.window,
          lagSize:this.lagSize,
          signal: this.rawData.slice(this.visibleRange[0],this.visibleRange[1]),
        })
        .then((response) => {

          this.r = response.data.r;
          console.log(response.data.lags)
          this.lags = response.data.lags.map(x=>x / this.samplingRate);
           this.series = [
        {
          x: this.lags,
          y: this.r,
        },
      ];
  Plotly.newPlot(
      this.$refs.plotly,
      this.series,
      this.layout,
      {
        displayModeBar: true,
        displaylogo: false,
        doubleClick: "reset",
        responsive: true,
      }
    );
        }).finally(()=>{
      this.chartLoading = false;

        });
       
    },
  
  },
  watch: {
      visibleRange:function(range){
        this.init();
    },
    rawData: function () {
      this.init();
    },
    lagSize: function () {
      this.init();
    },
    window: function () {
      this.init();
    },
  },
};
</script>
<style>
.apexcharts-toolbar {
  top: 15px !important;
  right: 5px !important;
}
</style>
<style scoped>
.measurementDelete {
  float: right;
}
*:focus {
  outline: -webkit-focus-ring-color auto 0px;
}
.apexcharts-tooltip.apexcharts-theme-light {
  line-height: 9px;
  padding-bottom: 0px;
}
.apexcharts-tooltip-series-group.apexcharts-active,
.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 0px;
}
.apexcharts-tooltip-series-group.apexcharts-active {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 0px;
}
</style>
